const style={
    border:"none",
    color:"#033362",
    fontSize:"14px",
    fontWeight:'lighter'
  }

const columns = [
  {
    name: "id",
    header: <h3 style={{ fontWeight: "700" }}>ID</h3>,
    defaultFlex: 0.5,
    headerProps: { style: style },
    className:"text-[14px] font-[400] text-[#0388CC]"
  },
  {
    name: "fullname",
    header: <h3 style={{ fontWeight: "700" }}>Full Name</h3>,
    defaultFlex: 1,
    headerProps: { style: style },
    className:"text-[14px] font-[400] text-[#0388CC]"
  },
  {
    name: "email",
    header: <h3 style={{ fontWeight: "700" }}>Email</h3>,
    defaultFlex: 1.5,
    headerProps: { style: style },
    className:"text-[14px] font-[400]"
  },
  {
    name: "phone",
    header: <h3 style={{ fontWeight: "700" }}>Phone</h3>,
    defaultFlex: 0.8,
    headerProps: { style: style },
    className:"text-[14px] w-fit px-[5px] font-[400] rounded text-[#0388CC] "
  },
  {
    name: "subject",
    header: <h3 style={{ fontWeight: "700" }}>Subject</h3>,
    defaultFlex: 1.2,
    headerProps: { style: style },
    className:"font-[400]"

  },
  {
    name: "content",
    header: <h3 style={{ fontWeight: "700" }}>Content</h3>,
    defaultFlex: 3,
    headerProps: { style: style },
    className:"font-[400]"

  },
  {
    name: "date",
    header: <h3 style={{ fontWeight: "700" }}>Date</h3>,
    defaultFlex: 0.8,
    headerProps: { style: style },
    className:"font-[400]"
  },
  {
    name: "reply",
    header: <h3 style={{ fontWeight: "700" }}>Reply</h3>,
    defaultFlex: 0.6,
    headerProps: { style: style },
  },
  {
    name:"viewMessage",
    header: "",
    defaultFlex:1.3,
    headerProps: { style: style },
  }
];

export default columns;
